import { isSortable } from "@dnd-kit/dom/sortable";
import type { DragDropEvents } from "@dnd-kit/react";
import { useCallback } from "react";

export const useGetDragEndEventHandler = <T extends { id: string }>(
  stateSetter: (setter: (prevState: T[]) => T[]) => void,
): DragDropEvents["dragend"] => {
  return useCallback(
    ({ operation: { source } }) => {
      stateSetter((items) => {
        if (!isSortable(source)) {
          return items;
        }

        // While dnd-kit provides a package with utilities to handle moving array
        // elements, I found it to be buggy and poorly documented. Opted for a
        // custom implementation instead.
        const initialIndex = items.findIndex(({ id }) => source.id === id);
        const targetIndex = source.index;

        if (
          initialIndex < 0 ||
          targetIndex < 0 ||
          initialIndex === targetIndex
        ) {
          return items;
        }

        const withoutItem = [
          ...items.slice(0, initialIndex),
          ...items.slice(initialIndex + 1),
        ];

        return [
          ...withoutItem.slice(0, targetIndex),
          items[initialIndex],
          ...withoutItem.slice(targetIndex),
        ];
      });
    },
    [stateSetter],
  );
};
